import $ from 'jquery';

function setBottomAdminPanel(){

    var $subFooter = $('.subFooter');

    if (window.matchMedia('(max-width: 991px)').matches) {
        if ($subFooter[0]) {
            $('#accordionAdminPanel').css('bottom', $subFooter.outerHeight() + 'px');
        }
    }
    else {
        $('#accordionAdminPanel').css('bottom', '0');
    }
}

$(document).ready(function (){
    setBottomAdminPanel();

    $(document).click(function (event) {
        var clickover = $(event.target);
        var collapseAdminPanel = $('#collapseAdminPanel');
        var _opened = collapseAdminPanel.hasClass('collapse in');
        if (_opened === true && !clickover.hasClass('adminPanelOnglet')&& !clickover.is('#collapseAdminPanel') && collapseAdminPanel.has(clickover).length === 0) {
            $('.adminPanelOnglet').click();
        }
    });

});

$(window).resize(function (){
    setBottomAdminPanel();
});
